<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveContinueBtnClick">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="因子名称" prop="displayName" :rules="[{
            required: true,
            message: '请输入因子名称'
          }]">
            <el-input v-model.trim="model.displayName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="别名" prop="alias">
            <el-input v-model.trim="model.alias" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
           <el-form-item label="中文名" prop="cnName">
              <el-input v-model.trim="model.cnName" />
            </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="英文名" prop="enName">
            <el-input v-model.trim="model.enName" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
<!--        <el-col :span="6">-->
<!--          <el-form-item label="因子代码" prop="factorCode" :rules="[{-->
<!--            required: true,-->
<!--            message: '请输入因子代码'-->
<!--          }]">-->
<!--            <el-input v-model.trim="model.factorCode" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="6">
          <el-form-item label="CAS" prop="cas">
            <el-input disabled v-model.trim="model.cas" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分组" prop="groupId" :rules="[{
            required: true,
            message: '请选择分组'
          }]">
            <el-select v-model="model.groupId" disabled style="width:100%;">
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="分子量" prop="molecular">
            <el-input disabled v-model.trim="model.molecular" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="可用单位" prop="allUnits">
            <el-input v-model.trim="model.allUnits" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标准单位" prop="stdUnit">
            <el-select v-model.trim="model.stdUnit" disabled style="width:100%;">
              <el-option
                v-for="item in unitList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="展示单位" prop="displayUnit">
            <el-select v-model.trim="model.displayUnit" style="width:100%;">
              <el-option
                v-for="item in unitList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="12">-->
<!--          <el-form-item label="标准" prop="codeType" :rules="[{-->
<!--            required: true,-->
<!--            message: '请输入标准'-->
<!--          }]">-->
<!--            <el-input v-model.trim="model.codeType" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--        <el-col :span="12">-->
<!--          <el-form-item label="根因子ID" prop="rootFactorId" :rules="[{-->
<!--            required: true,-->
<!--            message: '请输入根因子ID'-->
<!--          }]">-->
<!--            <el-input v-model.trim="model.rootFactorId" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--      </el-row>-->
      <el-row :gutter="gutter">
        <el-col :span="16">
          <el-form-item label="小数位数" prop="decimalNum" >
            <el-input v-model.trim="model.decimalNum" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="最低检出限" prop="detectionLimit">
            <el-input v-model.trim="model.detectionLimit" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="8">
          <el-form-item
            :label="`修正下限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="amendLowRange"
            :rules="{
              validator: amendLowRangeValidator
            }"
          >
            <el-input
              v-model.trim="model.amendLowRange"
              type="number"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`修正上限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="amendHighRange"
            :rules="{
              validator: amendHighRangeValidator
            }"
          >
            <el-input v-model.trim="model.amendHighRange" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`修正值${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="amendValue"
            :rules="{
              validator: amendValueValidator
            }"
          >
            <el-input v-model.trim="model.amendValue" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="12">
          <el-form-item
            :label="`超标下限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="limitLow"
          >
            <el-input v-model.trim="model.limitLow" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="`超标上限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="limitHigh"
            :rules="{
              validator: limitHighValidator
            }"
          >
            <el-input v-model.trim="model.limitHigh" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="是否报警" prop="isAlarm" >
        <el-switch v-model="model.isAlarm"></el-switch>
      </el-form-item>

      <el-row :gutter="gutter">
        <el-col :span="6">
          <el-form-item
            :label="`报警下限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="alarmMin"
            :rules="{
              validator: alarmMinValidator
            }"
          >
            <el-input v-model.trim="model.alarmMin" :disabled="!model.isAlarm" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="`报警上限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="alarmMax"
            :rules="{
              validator: alarmMaxValidator
            }"
          >
            <el-input v-model.trim="model.alarmMax" :disabled="!model.isAlarm" type="number" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="状态" prop="status" >
        <el-switch v-model="model.status"></el-switch>
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <el-button v-if="operator === 1" type="orange" plain class="btn save-continue-btn" @click="onSaveContinueBtnClick">保存并继续</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  props: {
    groupList: {
      required: true,
      type: Array
    }
  },
  computed: {
    unitList () {
      let allUnits = this.model.allUnits
      return allUnits ? [...new Set(allUnits.split('|'))].map(unit => ({
        value: unit,
        label: unit
      })) : []
    }
  },
  methods: {
    initModel () {
      return {
        alias: '',
        allUnits: '',
        cas: '',
        cnName: '',
        codeType: '',
        decimalNum: 0,
        detectionLimit: null,
        displayName: '',
        displayType: 0,
        displayUnit: '',
        enName: '',
        factorCode: '',
        groupId: '',
        id: null,
        mf: '',
        molecular: 0,
        rootFactorId: '',
        status: false,
        stdUnit: '',
        amendLowRange: null,
        amendHighRange: 0,
        amendValue: null,
        limitLow: null,
        limitHigh: null,
        isAlarm: false,
        alarmMax: '',
        alarmMin: '',
        type: 0
      }
    },
    amendLowRangeValidator (rule, value, callback) {
      let {amendHighRange} = this.model

      if (value === null || value === undefined || value === '') {
        if (amendHighRange === null || amendHighRange === undefined || amendHighRange === '') {
          return callback()
        }

        return callback(new Error('请输入修正下限值'))
      }

      return callback()
    },
    amendHighRangeValidator (rule, value, callback) {
      let {amendLowRange} = this.model

      if (value === null || value === undefined || value === '') {
        if (amendLowRange === null || amendLowRange === undefined || amendLowRange === '') {
          return callback()
        }

        return callback(new Error('请输入修正上限值'))
      } else {
        if (Number(value) < Number(amendLowRange)) {
          return callback(new Error('修正上限值必须大于修正下限值'))
        }
      }

      return callback()
    },
    amendValueValidator (rule, value, callback) {
      let {amendLowRange, amendHighRange} = this.model

      if (value === null || value === undefined || value === '') {
        if ((amendLowRange === null || amendLowRange === undefined || amendLowRange === '') && (amendHighRange === null || amendHighRange === undefined || amendHighRange === '')) {
          return callback()
        } else {
          return callback(new Error('请输入修正值'))
        }
      }

      value = Number(value)

      if (Number(amendLowRange) <= value && Number(amendHighRange) >= value) {
        return callback(new Error('请修正值不能在修正上下限范围内'))
      }

      return callback()
    },
    limitHighValidator (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        return callback()
      }

      let {limitLow} = this.model

      if (limitLow === null || limitLow === undefined || limitLow === '') {
        return callback()
      }

      if (value > limitLow) {
        return callback()
      }

      return callback(new Error('超标上限值必须大于超标下限值'))
    },
    alarmMinValidator (rule, value, callback) {
      let {isAlarm, alarmMax} = this.model
      let valueIsEmpty = value === null || value === undefined || value === ''
      let alarmMaxIsEmpty = alarmMax === null || alarmMax === undefined || alarmMax === ''

      if ((isAlarm || !alarmMaxIsEmpty)) {
        if (valueIsEmpty) {
          return callback(new Error('请填写报警下限'))
        } else if (Number(value) >= Number(alarmMax)) {
          return callback(new Error('报警下限必须小于报警上限'))
        }
      }

      callback()
    },
    alarmMaxValidator (rule, value, callback) {
      let {isAlarm, alarmMin} = this.model
      let alarmMinIsEmpty = alarmMin === null || alarmMin === undefined || alarmMin === ''
      let valueIsEmpty = value === null || value === undefined || value === ''

      if (isAlarm || !alarmMinIsEmpty) {
        if (valueIsEmpty) {
          return callback(new Error('请填写报警上限'))
        } else {
          if (Number(value) <= Number(alarmMin)) {
            return callback(new Error('报警上限必须大于报警下限'))
          }
        }
      }

      callback()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/04Factor/Editor.vue